import { __spreadArray } from '../../../../../../../node_modules/tslib/tslib.es6.js';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import linear from '../../../../../../../node_modules/d3-scale/src/linear.js';

var THRESHOLD = 14;
function useChartColor() {
    var theme = useTheme();
    return {
        green: theme.palette.chart.green,
        red: theme.palette.chart.red,
    };
}
var useTicks = function (data, yDomain, tickCount, onlyIntegerTicks, showCurrentTick, height) {
    if (onlyIntegerTicks === void 0) { onlyIntegerTicks = false; }
    if (showCurrentTick === void 0) { showCurrentTick = false; }
    if (height === void 0) { height = 0; }
    return useMemo(function () {
        var _a;
        var lastDataY = (_a = data[data.length - 1]) === null || _a === void 0 ? void 0 : _a.y;
        var ticks = linear()
            .domain(yDomain)
            .ticks(tickCount)
            .filter(function (v) { return !onlyIntegerTicks || Number.isInteger(v); });
        if (!showCurrentTick) {
            return ticks;
        }
        var scale = linear().domain(yDomain).range([0, height]);
        var lastDataPointPositionScaled = scale(lastDataY);
        var overlapsExistingTick = ticks.find(function (existingTickPosition) {
            var existingTickPositionScaled = scale(existingTickPosition);
            return Math.abs(existingTickPositionScaled - lastDataPointPositionScaled) < THRESHOLD;
        });
        var adjustedTicks = overlapsExistingTick
            ? ticks.filter(function (tick) { return tick !== overlapsExistingTick; })
            : ticks;
        return __spreadArray(__spreadArray([], adjustedTicks, true), [lastDataY], false);
    }, [data, yDomain, tickCount, onlyIntegerTicks, height]);
};

export { useChartColor, useTicks };
